import React from "react";
import { Cloud } from "lucide-react";
import { CONSTANTS } from "../data";

interface EnvironmentalDisplayProps {
  enabled: boolean;
  timeOfDay: string;
  humidity: number;
  containerWidth?: number;
  containerPadding?: number;
}

const EnvironmentalDisplay: React.FC<EnvironmentalDisplayProps> = ({
  enabled,
  timeOfDay,
  humidity,
  containerWidth = 320,
  containerPadding = 16,
}) => {
  if (!enabled) return null;

  const timeData = CONSTANTS.ENVIRONMENTAL_MODIFIERS.timeOfDay[timeOfDay];
  const humidityLevel =
    humidity < CONSTANTS.ENVIRONMENTAL_MODIFIERS.humidity.LOW.threshold
      ? "LOW"
      : humidity < CONSTANTS.ENVIRONMENTAL_MODIFIERS.humidity.NORMAL.threshold
      ? "NORMAL"
      : "HIGH";
  const humidityData =
    CONSTANTS.ENVIRONMENTAL_MODIFIERS.humidity[humidityLevel];

  // Calculate responsive sizing based on container
  const iconSize = Math.max(12, Math.min(20, containerWidth * 0.05));
  const titleFontSize = Math.max(10, Math.min(16, containerWidth * 0.04));
  const detailsFontSize = Math.max(8, Math.min(14, containerWidth * 0.035));
  const padding = Math.max(6, Math.min(12, containerPadding * 0.5));

  return (
    <div className="bg-bg-main rounded-lg border border-border-color" style={{ padding: `${padding}px` }}>
      <div className="flex items-center mb-1" style={{ gap: `${Math.max(2, padding / 2)}px` }}>
        <Cloud size={iconSize} className="text-primary-action" />
        <span className="font-semibold text-text-primary" style={{ fontSize: `${titleFontSize}px` }}>
          {containerWidth < 200 ? 'Env' : 'Environment'}
        </span>
      </div>
      <div className="space-y-0.5 text-text-secondary" style={{ fontSize: `${detailsFontSize}px` }}>
        <div>
          {containerWidth < 200 ? 'T:' : 'Time:'} {containerWidth < 200 ? timeOfDay.slice(0, 3) : timeOfDay}{" "}
          {timeData?.temperatureOffset
            ? `(${timeData.temperatureOffset > 0 ? "+" : ""}${
                timeData.temperatureOffset
              }°)`
            : ""}
        </div>
        <div>
          {containerWidth < 200 ? 'H:' : 'Humidity:'} {humidity}% ({containerWidth < 200 ? humidityLevel.slice(0, 1) : humidityLevel})
        </div>
        <div className="text-primary-action" style={{ fontSize: `${Math.max(6, detailsFontSize - 1)}px` }}>
          {containerWidth < 200 ? humidityData.effect.slice(0, 10) + '...' : humidityData.effect}
        </div>
      </div>
    </div>
  );
};

export default EnvironmentalDisplay;
